var path = 'components/packages/tooltips/subscriptionsEPSS.html';
var html = "<div class=tooltip-list> <div ng-repeat=\"ps in paymentSystemsForTemplate\"> <span access=\"\" ng-bind=\"vm.payment_system_types[ps.paymentSystemType] || ps.paymentSystemType\"></span> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;